import React from 'react'

export default function Goals() {
  return <div>Goals</div>
}
